import { render } from "./BankDetails.vue?vue&type=template&id=5fcff23a&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"

import "./BankDetails.vue?vue&type=style&index=0&id=5fcff23a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcff23a"]])

export default __exports__